import { productReducer } from './reducer';

export function productStoreRegister() {
    return {
        name: 'product-store',
        epics: [],
        reducers: {
            products: productReducer,
        },
    };
}
